import { Component } from '@angular/core';

@Component({
  selector: 'app-warning-icon',
  standalone: true,
  host: { class: 'ui-icon' },
  templateUrl: './warning-icon.component.html',
  styleUrl: '../icon-base.scss'
})
export class WarningIconComponent {}
